import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export default function AuthRedirect() {
  const location = useLocation();
  const [message, setMessage] = useState("Wait...");
  const buttonRef = useRef(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (buttonRef.current) {
        buttonRef.current.click();
      }
    }, 500);
  }, [location.search]);

  const handleClick = async (e) => {
    e.preventDefault();

    const query = new URLSearchParams(location.search);
    const continueUrl = query.get("continueUrl");

    if (continueUrl) {
      setMessage("Redirecting to mobile...");

      window.location.href = continueUrl;
    } else {
      console.warn("Invalid parameters");
      setMessage("Invalid parameters. Please try again.");
      setHasError(true);
    }
  };

  return (
    <div>
      <div>{message}</div>
      <br />
      {!hasError && (
        <button ref={buttonRef} onClick={handleClick}>
          Click here if it doesn't open automatically.
        </button>
      )}
    </div>
  );
}
